import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_DRIVERS_GET_BY_USER_ID } from 'api/actionTypes';

export default async function getByUserId({ state, apiClient }, { userId, force = false }) {
  typeCheck('userId::PositiveNumber', userId);

  const statePath = ['drivers', 'current'];
  if (state.get(statePath) && !force) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_DRIVERS_GET_BY_USER_ID,
    queryId: String(userId),
    state: state,
    payload: {
      userId: userId,
    },
    onSuccess(partner) {
      state.set(statePath, partner);
    },
  });
}
